// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* สีพื้นและสีตัวหนังสือของหัวข้อ (option-label) */
ul.select-dropdown li.option-label {
  background-color: #26a69a !important;   /* เปลี่ยนได้ตามชอบ */
}

ul.select-dropdown li.option-label span {
  color: #fff !important;              /* เปลี่ยนสีตัวหนังสือ */
  font-weight: 700;
  opacity: 1;
  pointer-events: none;
}

/* กันสีเข้มจาก active/selected ของ materialize */
ul.multiple-select-dropdown li.active,
ul.multiple-select-dropdown li.selected {
  background-color: transparent !important;
}

/* กัน active/selected ของ materialize มาทับ */
ul.select-dropdown li.option-label.active,
ul.select-dropdown li.option-label.selected {
  background-color: #26a69a !important;
  color: #fff !important;
}

/* ถ้าอยากคง hover เบา ๆ สำหรับ option ปกติ */
ul.select-dropdown li:not(.option-label):hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

/* Placeholder style → ให้จางกว่า label */
ul.select-dropdown li.option-placeholder {
  background-color: #f5f5f5 !important; /* สีอ่อน */
  color: #999 !important;               /* ตัวอักษรเทา */
  font-style: italic;
  cursor: default !important;
  pointer-events: none;
  opacity: 1 !important;
}

/* กันไม่ให้ placeholder ถูก active */
ul.select-dropdown li.option-placeholder.active {
  background-color: #f5f5f5 !important;
  color: #999 !important;
}

/* helper text สำหรับทุก select */
.helper-text {
  color: #1976d2 !important; /* ฟ้า Materialize */
  font-size: 0.85rem;
}

`, "",{"version":3,"sources":["webpack://./src/components/Team/selectDropdownPatch.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;EACE,oCAAoC,IAAI,qBAAqB;AAC/D;;AAEA;EACE,sBAAsB,eAAe,wBAAwB;EAC7D,gBAAgB;EAChB,UAAU;EACV,oBAAoB;AACtB;;AAEA,iDAAiD;AACjD;;EAEE,wCAAwC;AAC1C;;AAEA,8CAA8C;AAC9C;;EAEE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,6CAA6C;AAC7C;EACE,gDAAgD;AAClD;;AAEA,yCAAyC;AACzC;EACE,oCAAoC,EAAE,WAAW;EACjD,sBAAsB,gBAAgB,gBAAgB;EACtD,kBAAkB;EAClB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA,iCAAiC;AACjC;EACE,yBAAyB,EAAE,oBAAoB;EAC/C,kBAAkB;AACpB","sourcesContent":["/* สีพื้นและสีตัวหนังสือของหัวข้อ (option-label) */\r\nul.select-dropdown li.option-label {\r\n  background-color: #26a69a !important;   /* เปลี่ยนได้ตามชอบ */\r\n}\r\n\r\nul.select-dropdown li.option-label span {\r\n  color: #fff !important;              /* เปลี่ยนสีตัวหนังสือ */\r\n  font-weight: 700;\r\n  opacity: 1;\r\n  pointer-events: none;\r\n}\r\n\r\n/* กันสีเข้มจาก active/selected ของ materialize */\r\nul.multiple-select-dropdown li.active,\r\nul.multiple-select-dropdown li.selected {\r\n  background-color: transparent !important;\r\n}\r\n\r\n/* กัน active/selected ของ materialize มาทับ */\r\nul.select-dropdown li.option-label.active,\r\nul.select-dropdown li.option-label.selected {\r\n  background-color: #26a69a !important;\r\n  color: #fff !important;\r\n}\r\n\r\n/* ถ้าอยากคง hover เบา ๆ สำหรับ option ปกติ */\r\nul.select-dropdown li:not(.option-label):hover {\r\n  background-color: rgba(0, 0, 0, 0.04) !important;\r\n}\r\n\r\n/* Placeholder style → ให้จางกว่า label */\r\nul.select-dropdown li.option-placeholder {\r\n  background-color: #f5f5f5 !important; /* สีอ่อน */\r\n  color: #999 !important;               /* ตัวอักษรเทา */\r\n  font-style: italic;\r\n  cursor: default !important;\r\n  pointer-events: none;\r\n  opacity: 1 !important;\r\n}\r\n\r\n/* กันไม่ให้ placeholder ถูก active */\r\nul.select-dropdown li.option-placeholder.active {\r\n  background-color: #f5f5f5 !important;\r\n  color: #999 !important;\r\n}\r\n\r\n/* helper text สำหรับทุก select */\r\n.helper-text {\r\n  color: #1976d2 !important; /* ฟ้า Materialize */\r\n  font-size: 0.85rem;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
